import { Controller } from "@hotwired/stimulus"
export default class extends Controller {
  static values = {
    selector: String,
    enabled: { type: Boolean, default: true }
  }

  connect() {
    if (!this.enabledValue) return

    const invalidField = this.invalidField
    if (invalidField) {
      invalidField.focus()
      this.scrollIntoField(invalidField)
    }
  }

  get invalidField() {
    return Array.from(this.element.querySelectorAll(this.selectorValue)).find(field => field.getClientRects().length > 0)
  }

  scrollIntoField(field) {
    let elementRect = field.getBoundingClientRect()
    let absoluteElementTop = elementRect.top + window.pageYOffset
    let middle = absoluteElementTop - (window.innerHeight / 2)
    window.scrollTo(0, middle)
  }
}
